







import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ClassItem from '../../../models/interfaces/ClassItem';
import ClassItemRate from '../../../models/interfaces/ClassItemRate';
import Stars from '../../ScoreInput/Stars.vue';

@Component({ components: { Stars } })
export default class ClassLikeDislike extends Vue {
  @Prop({ required: true })
  public readonly item!: ClassItem;

  @Prop({ required: true })
  public readonly value!: ClassItemRate;

  @Watch('value.score')
  public updateLike(score: number) {
    if (score >= 1 && score <= 3) this.value.like = false;
    else if (score >= 4 && score <= 5) this.value.like = true;
    else this.value.like = null;

    this.$emit('input', this.value);
  }
}
